module.exports = __webpack_public_path__ + "static/bellnomina1.fd38feb2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/bellnomina1.jpeg
// module id = 1258
// module chunks = 35783957827783